<template>
  <div class="w-full space-y-1">
    <label class="text-sm text-gray-600 font-medium">
      {{ answerLabel }}
    </label>

    <div class="flex items-center gap-2">

      <div class="flex flex-grow rounded-md border border-gray-300 overflow-hidden bg-white">
        <input
            v-model="text"
            :placeholder="__('Add a possible answer')"
            class="flex-grow px-3 md:px-4 py-2.5 text-sm md:text-base outline-none border-0 min-w-0"
            required
            :disabled="disabled"
        />

        <div class="flex items-stretch border-l border-gray-300 divide-x divide-gray-300 flex-shrink-0">
          <button
              type="button"
              @click="markIncorrect"
              :class="!isCorrect ? 'bg-zinc-400' : 'bg-white'"
              class="w-8 md:w-10 flex items-center justify-center transition-colors"
              :title="__('Mark incorrect')"
              :disabled="disabled"
          >
            <Icon name="close" class="w-4 md:w-5 h-4 md:h-5" :class="!isCorrect ? 'text-white' : 'text-[#52525B]'" />
          </button>

          <button
              v-if="answerType === 'single'"
              type="button"
              @click="markSingleCorrect"
              :class="isCorrect ? 'bg-secondary' : 'bg-white'"
              class="w-8 md:w-10 flex items-center justify-center transition-colors"
              :title="__('Mark correct')"
              :disabled="disabled"
          >
            <Icon name="check" class="w-4 md:w-5 h-4 md:h-5" :class="isCorrect ? 'text-white' : 'text-[#52525B]'" />
          </button>

          <button
              v-else
              type="button"
              @click="toggleCorrect"
              :class="isCorrect ? 'bg-secondary' : 'bg-white'"
              class="w-8 md:w-10 flex items-center justify-center transition-colors"
              :title="__('Toggle correct')"
              :disabled="disabled"
          >
            <Icon name="check" class="w-4 md:w-5 h-4 md:h-5" :class="isCorrect ? 'text-white' : 'text-[#52525B]'" />
          </button>
        </div>
      </div>

      <button
          v-if="removable && !disabled"
          type="button"
          @click="$emit('remove')"
          class="w-8 md:w-10 h-8 md:h-10 flex-shrink-0 flex items-center justify-center text-red-500 hover:bg-red-100 rounded-md transition-colors"
          :title="__('Delete answer')"
      >
        <Icon name="delete" class="w-4 md:w-5 h-4 md:h-5" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Icon } from '@/components/block/icon';
import { __ } from '@/helpers';

const props = defineProps({
  ans:         { type: Object, required: true },
  answerType:  { type: String, required: true },
  removable:   { type: Boolean, required: true },
  index:       { type: Number, required: true },
  disabled:    { type: Boolean, default: false },
});
const emit = defineEmits(['update:ans','remove','single-selected']);

const text = computed({
  get:  ()    => props.ans.text,
  set: val   => emit('update:ans', { ...props.ans, text: val || '' })
});

const isCorrect = computed({
  get:  ()    => Boolean(props.ans.is_correct),
  set: val   => emit('update:ans', { ...props.ans, is_correct: val })
});

function markIncorrect() {
  if (props.disabled) return;
  isCorrect.value = false;
}
function markSingleCorrect() {
  if (props.disabled) return;
  isCorrect.value = true;
  emit('single-selected');
}
function toggleCorrect() {
  if (props.disabled) return;
  isCorrect.value = !isCorrect.value;
}

const answerLabel = `Answer ${props.index + 1}`;
</script>
